import React, { useEffect, useRef, useState } from 'react'
import { getLocations, getSubAccountLocations } from '../../services/userservice';
import { BulkMapICCID } from '../../services/bookingservice';
import { hasDuplicates, isNormalInteger } from '../../utils/util';
import { getSession } from '../../global';
import { useSelector, useDispatch } from 'react-redux';
import { setLoading } from '../../redux/appSlice';
import { setData, setFileLen, setGrid, setGridStatus, setFileName } from '../../redux/mapICCICSlice';
import Grid from './grid';
import { calculateErrors } from './calculateerrors';

const Form = ({ myWorker }) => {
    const dispatch = useDispatch();
    const state = useSelector(state => { return { appData: state.appData, MapICCIDData: state.MapICCIDData } });
    const { destinations, loading, userInfo, types, subaccounts, services, codAmountLimit } = state.appData;
    const {
        data,
        fileLen,
        fileType,
        fileName,
        grid } = state.MapICCIDData;

    const userid = getSession('userId')
    const dests = destinations.map(x => x.text);

    const [locations, setLocations] = useState([]);

    const updateData = (key, val) => {
        const d = { ...data, [key]: val };
        dispatch(setData({ data: d }));
    };

    const fileRef = useRef(null);

    useEffect(() => {
        myWorker.onmessage = function (event) {
            fileRef.current.value = null;
            dispatch(setFileLen({ data: 0 }));
            dispatch(setFileName({ data: '' }));
            const { sts, msg, dt } = event.data;
            if (sts === 0) {
                if (dt.length > 999) {
                    alert('Maximum Booking length is 1000.');
                    return false;
                }
                dispatch(setGrid({ data: dt }));
            } else {
                alert(msg);
            }
            dispatch(setLoading({ data: false }));
        }
    }, [])

    const onUpload = async () => {
        dispatch(setLoading({ data: false }));
        const file = fileRef.current.files[0];
        const type = 5;
        myWorker.postMessage({ file: file, type: type, destinations: destinations });
    }

    const validateExcel = () => {

        if (grid.filter(x => !x.Consignment).length > 0) {
            alert('Consignment No is required');
            return false;
        } else {
            const cns = grid.map(x => x.Consignment);
            if (hasDuplicates(cns)) {
                alert('Duplicate Consignment No are not allowed');
                return false;
            } 
            //else {
                //const sequnce = getSession('sequences').filter(x => x.locationId == data.locationId)[0];
                //const start = Number(sequnce.sequenceStart);
                //const end = Number(sequnce.sequenceEnd);
                // for (const x of grid) {
                //     let num = Number(x.Consignment);
                //     if (!(num >= start && num <= end)) {
                //         alert(`Invalid Consignment# ${num}`);
                //         return false;
                //     }
                // }
            //}
        }
        

        if (grid.filter(x => !x.CustomerReferenceNumber || x.CustomerReferenceNumber.trim() == '').length > 0) {
            alert('Customer Reference Number not found');
            return false;
        }

        if (!userInfo.isDuplicateOrderAllowed) {
            const refno = grid.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => x.CustomerReferenceNumber);
            if (hasDuplicates(refno)) {
                alert('Duplicate CustomerReferenceNumber not allowed');
                return false;
            }
        }

        if (grid.filter(x => !x.ICCID || x.ICCID.trim() == '').length > 0) {
            alert('ICCID is required');
            return false;
        }

        return true;
    }

    const onSave = async () => {
        if (validateExcel()) {
            var d = {
                userId: userid,
                Data: grid.map(y => {
                    return {
                        ConsignmentNumber: y.Consignment,
                        ICCID: y.ICCID,
                        RefNo: y.CustomerReferenceNumber
                    }
                })
            };
            dispatch(setLoading({ data: true }));
            const rs = await BulkMapICCID(d);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                alert("ICCID Maped");
                dispatch(setGrid({ data: [] }));
                dispatch(setGridStatus({ data: rs.data }));
            } else {
                alert(rs.msg);
            }
        }
    }

    useEffect(() => {
        dispatch(setGrid({ data: [] }));
    }, [data.subAccountId])


    const fileUploadCheck = (event) => {
        if (!data.subAccountId) {
            alert('Select Sub Account');
            event.preventDefault();
            return false;
        }
        if (!data.locationId) {
            alert('Select Location');
            event.preventDefault();
            return false;
        }
    }

    return (
        <>
            <div className="row">
                <datalist id="dests">
                    {
                        dests.map((x, index) => <option key={index} value={x} />)
                    }
                </datalist>
                {/* <div className="col-lg">
                    <label>Type</label>
                    <select className="form-select" value={data.isCod ? 1 : 0} onChange={(e) => {
                        const d = { ...data, isCod: e.target.value == 1, locationId: '', autoCN: null, subAccountId: '' };
                        dispatch(setData({ data: d }));
                        setLocations([]);
                    }}>
                        {
                            types.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        const autoCn = e.target[e.target.selectedIndex].getAttribute('data-autocn');
                        const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                        const d = { ...data, subAccountId: val, locationId: '', autoCN: autoCn ? autoCn === 'true' : null, accountNo: accno };
                        dispatch(setData({ data: d }));
                        if (val) {
                            const locs = await getLocations(userInfo?.id, accno)
                            // const locs = await getSubAccountLocations(userInfo.id, val)
                            if (locs)
                                setLocations(locs);
                        } else {
                            setLocations([]);
                        }
                    }}>
                        <option value="" data-autocn={null} data-accno="">Select Sub Account</option>
                        {
                            subaccounts.filter(x => x.isCod == data.isCod).map((x, index) => <option key={index} value={x.id} data-autocn={x.autoCN} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => updateData('locationId', e.target.value)}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div> */}
                <div className="col-lg">
                    <label>File</label>
                    <input
                        // onClick={fileUploadCheck}
                        type='file'
                        ref={fileRef}
                        className='form-control'
                        onChange={(e) => {
                            dispatch(setFileName({ data: e.target.files.length > 0 ? e.target.files[0].name : '' }))
                            dispatch(setFileLen({ data: e.target.files.length }))
                        }}
                        style={{
                            height: '37px',
                            padding: '7.5px 13px'
                        }}
                    />
                </div>
                <div className="col-lg" style={{ textAlign: "right" }}>
                    
                        <a href="MapICCID.xlsx" download className="btn btn-primary badge-orange" style={{
                            marginTop: '1.5rem', height: '37px',
                            padding: '7.5px 13px'
                        }}>Excel Sample</a>
                               
                </div>
            </div>
            <div className="sticky">
                <div id="errorDiv">
                    <div className="table table-sm table-bordered" style={{ color: 'red', marginTop: "30px" }}>
                        <div className='row' style={{ maxHeight: '200px', overflow: 'auto' }}>
                            {
                                calculateErrors(grid, userInfo).length > 0 && <span style={{ fontSize: "20px" }}>Error Counts ({calculateErrors(grid, userInfo).length}){" - "}
                                    {calculateErrors(grid, userInfo)[0].fieldName}: {calculateErrors(grid, userInfo)[0].error} {" "} <button type="button" className="btn btn-primary" onClick={() => {
                                        document.getElementById(`${calculateErrors(grid, userInfo)[0].key}${calculateErrors(grid, userInfo)[0].index + 1}`).focus({ focusVisible: true })
                                    }}>Go</button></span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg" style={{ textAlign: 'right' }}>
                        <button type="button" className="btn btn-primary" disabled={fileLen === 0} onClick={onUpload}>Upload</button>
                        <button type="button" className="btn btn-primary" style={{ marginLeft: 2 }} disabled={grid.length <= 0} onClick={onSave}>Save</button>
                    </div>
                </div>

                {grid && grid.length > 0 && <Grid grid={grid} />}
            </div>

        </>
    )
}

export default Form;
